import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { ConnectTerminalTelematics } from '@/components/ConnectTerminalTelematics'
import { CacheKeys } from '@/lib/cache'
import { useVaultTree } from '@/models/vault'
import { IntakeEmailButton } from './IntakeEmailButton'
import { SendToCaiButton } from './SendToCaiButton'
import { useVault } from './VaultContext'
import { VaultScopeSummary } from './VaultScopeSummary'
import { VaultTitle } from './VaultTitle'

export { VAULT_TITLE } from './VaultTitle'

/** The open vault's header: the page title, the ways documents get in, and the confirmed scope. */
export function VaultHeroBlock() {
  const { orgId, staff } = useVault()
  // The same query the folders read, so the header costs no extra request.
  const { intakeEmail, eldConnected } = useVaultTree(orgId)
  const queryClient = useQueryClient()
  return (
    <div className="flex flex-col gap-4">
      {/* Both open as the signed-in person; staff would be acting as themselves. */}
      <VaultTitle
        subtitle
        aside={
          staff ? undefined : (
            <div className="flex flex-wrap items-center gap-2">
              {!eldConnected && (
                <ConnectTerminalTelematics
                  type="POST_BIND"
                  handleSuccess={() => {
                    toast.success('ELD connected. Your roster fills in as it syncs.')
                    void queryClient.invalidateQueries({ queryKey: [CacheKeys.VAULT_TREE] })
                  }}
                  buttonProps={{ variant: 'outline', children: 'Connect your ELD' }}
                />
              )}
              <SendToCaiButton />
            </div>
          )
        }
      />
      {intakeEmail && (
        <div className="flex flex-wrap items-center gap-2">
          <IntakeEmailButton intakeEmail={intakeEmail} />
        </div>
      )}
      <VaultScopeSummary />
    </div>
  )
}
